import {
  agentList, agentStatus, agentInfo, agentSave, agentInsert,
  saveExtract, AgentMachine, SearchAgent, TransferMeterIncrement, BuyMeterIncrement,
  BuyIncrement, TransferIncrement, GetIncrement, MeterIncrementApply, IncrementApply, GetProfitReport,
  GetOperateCode, GetAgentOperateCode, ActivateCode, SaveLogo, MakeActivation, SaveAgentLogo, SendTelCode, AgentSaveLeader, CodeCheck, IncrementDelete, DismissIncrement,GetAgentTrack,SaveAgentTrack
} from '@/api/agent'
export default {
  state: {

  },
  actions: {
    getAgentList({ commit }, payload) {
      return new Promise((resolve, reject) => {
        agentList(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    putAgentIsDel({ commit }, payload) {
      return new Promise((resolve, reject) => {
        agentStatus(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getAgentInfo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        agentInfo(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    saveAgent({ commit }, payload) {
      return new Promise((resolve, reject) => {
        agentSave(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    insertAgent({ commit }, payload) {
      return new Promise((resolve, reject) => {
        agentInsert(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    saveExtract({ commit }, payload) {
      return new Promise((resolve, reject) => {
        saveExtract(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    AgentMachine({ commit }, payload) {
      return new Promise((resolve, reject) => {
        AgentMachine(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    SearchAgent({ commit }, payload) {
      return new Promise((resolve, reject) => {
        SearchAgent(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    TransferMeterIncrement({ commit }, payload) {
      return new Promise((resolve, reject) => {
        TransferMeterIncrement(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    BuyMeterIncrement({ commit }, payload) {
      return new Promise((resolve, reject) => {
        BuyMeterIncrement(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    BuyIncrement({ commit }, payload) {
      return new Promise((resolve, reject) => {
        BuyIncrement(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    TransferIncrement({ commit }, payload) {
      return new Promise((resolve, reject) => {
        TransferIncrement(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetIncrement({ commit }, payload) {
      return new Promise((resolve, reject) => {
        GetIncrement(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    MeterIncrementApply({ commit }, payload) {
      return new Promise((resolve, reject) => {
        MeterIncrementApply(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    IncrementApply({ commit }, payload) {
      return new Promise((resolve, reject) => {
        IncrementApply(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetOperateCode({ commit }, payload) {
      return new Promise((resolve, reject) => {
        GetOperateCode(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetAgentOperateCode({ commit }, payload) {
      return new Promise((resolve, reject) => {
        GetAgentOperateCode(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    ActivateCode({ commit }, payload) {
      return new Promise((resolve, reject) => {
        ActivateCode(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    SaveLogo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        SaveLogo(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    SaveAgentLogo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        SaveAgentLogo(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    MakeActivation({ commit }, payload) {
      return new Promise((resolve, reject) => {
        MakeActivation(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    SendTelCode({ commit }, payload) {
      return new Promise((resolve, reject) => {
        SendTelCode(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    AgentSaveLeader({ commit }, payload) {
      return new Promise((resolve, reject) => {
        AgentSaveLeader(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    CodeCheck({ commit }, payload) {
      return new Promise((resolve, reject) => {
        CodeCheck(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetProfitReport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        GetProfitReport(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    IncrementDelete({ commit }, payload) {
      return new Promise((resolve, reject) => {
        IncrementDelete(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    DismissIncrement({ commit }, payload) {
      return new Promise((resolve, reject) => {
        DismissIncrement(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    SaveAgentTrack({ commit }, payload) {
      return new Promise((resolve, reject) => {
        SaveAgentTrack(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetAgentTrack({ commit }, payload) {
      return new Promise((resolve, reject) => {
        GetAgentTrack(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },

  },
  getters: {

  },
  mutations: {

  }
}
